module.exports = __webpack_public_path__ + "static/media/crosshair.6ac647fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/crosshair.svg
// module id = 137
// module chunks = 0